/* ==========================================================================
   NEW PDP — core UMF (Monday 12484480660) · added 06-Oct-2026
   Loaded only by sections/cumf-main.liquid (?view=core-umf).
   - size tiles → hidden variant id, price, hero image, URL ?variant=
   - one-time vs Subscribe & Save (Recharge selling plans from Liquid)
   - qty stepper, gallery carousel + thumbs, full-screen zoom
   - sticky add-to-cart bar, video on tap, FAQ "show all", accreditations
   - analytics: every interaction pushes a `cumf_*` event to dataLayer
     (GA4 via GTM) with arm: 'core-umf' so the two test arms can be split.
   Add to cart itself is the theme's <product-form> — not re-implemented here.
   ========================================================================== */
(function () {
  'use strict';

  function track(name, params) {
    var payload = Object.assign({ event: 'cumf_' + name, pdp_arm: 'core-umf' }, params || {});
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('nzhc:pdp', { detail: payload })); } catch (e) {}
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var n = Number(cents) / 100;
    function withDelims(num, decimals, thou, dec) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }

  function initMain(root) {
    var dataEl = root.querySelector('[data-cumf-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var money = function (c) { return formatMoney(c, data.moneyFormat).replace(/\s+[A-Z]{3}$/, ''); };
    // Non-USD markets (CAD, AUD) show the code after the headline prices, like the standard PDP ("$48.00 CAD").
    // .ae: the money format already says "Dhs." — no code suffix (data.showCode === false)
    var curSfx = data.showCode === false ? '' : (data.currency && data.currency !== 'USD' ? ' ' + data.currency : '');
    var T = data.i18n || {};
    var tx = function (k, d) { return T[k] || d; };
    var moneyC = function (c) { return money(c) + curSfx; };
    var byId = {};
    data.variants.forEach(function (v) { byId[v.id] = v; });

    var state = { id: data.currentId, plan: 'once', freq: data.defaultFreq || 4, qty: 1 };

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var idInput = $('[data-cumf-id]');
    var planInput = $('[data-cumf-plan-input]');
    var qtyInput = $('[data-cumf-qty-input]');
    var atc = $('[data-cumf-atc]');
    var atcLabel = $('[data-cumf-atc-label]');
    var priceEl = $('[data-cumf-price]');
    var wasEl = $('[data-cumf-was]');
    var heroImg = $('[data-cumf-hero]');
    var pointsEl = $('[data-cumf-points]');
    var stickyImg = $('[data-cumf-sticky-img]');

    function planFor(v) {
      if (state.plan !== 'sub' || !v || !v.plans) return null;
      return v.plans[String(state.freq)] || v.plans['4'] || null;
    }

    function unitPrice(v) {
      var p = planFor(v);
      return p ? p.price : v.price;
    }

    function perText(v, unit) {
      if (v.kind === 'packets') return money(Math.round(unit / 10)) + tx('perPacket', '/packet');
      if (v.g) return money(Math.round(unit / (v.g / 7))) + tx('perServe', '/serve');
      return '';
    }

    function render() {
      var v = byId[state.id];
      if (!v) return;
      var plan = planFor(v);
      var unit = plan ? plan.price : v.price;

      idInput.value = v.id;
      if (plan) { planInput.value = plan.id; planInput.disabled = false; }
      else { planInput.value = ''; planInput.disabled = true; }
      qtyInput.value = state.qty;
      var q = $('[data-cumf-qty-label]');
      if (q) q.textContent = state.qty;

      priceEl.textContent = moneyC(unit);
      if (plan && plan.price < v.price) { wasEl.textContent = moneyC(v.price); wasEl.hidden = false; }
      else { wasEl.hidden = true; }

      // tiles
      $$('[data-cumf-tile]').forEach(function (t) {
        var tv = byId[t.getAttribute('data-id')];
        var on = String(tv && tv.id) === String(v.id);
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (!tv) return;
        var u = unitPrice(tv);
        var pe = t.querySelector('[data-cumf-tile-price]');
        var pp = t.querySelector('[data-cumf-tile-per]');
        if (pe) pe.textContent = money(u);
        if (pp) pp.textContent = perText(tv, u);
      });

      // plan rows
      var once = $('[data-cumf-plan-price="once"]');
      var sub = $('[data-cumf-plan-price="sub"]');
      if (once) once.textContent = moneyC(v.price);
      if (sub) {
        var sp = v.plans && (v.plans[String(state.freq)] || v.plans['4']);
        sub.textContent = sp ? moneyC(sp.price) : '';
        var subRow = $('[data-cumf-plan="sub"]');
        if (subRow) subRow.hidden = !sp;
      }
      $$('[data-cumf-plan]').forEach(function (r) {
        var on = r.getAttribute('data-cumf-plan') === state.plan;
        r.classList.toggle('is-on', on);
        r.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      $$('[data-cumf-freq]').forEach(function (b) {
        b.classList.toggle('is-on', Number(b.getAttribute('data-cumf-freq')) === state.freq);
      });

      // serving-cost rows follow the selected plan
      $$('[data-cumf-serve]').forEach(function (row) {
        var rv = byId[row.getAttribute('data-id')];
        var el = row.querySelector('[data-cumf-serve-price]');
        if (rv && el && rv.g) el.textContent = money(Math.round(unitPrice(rv) / (rv.g / 7)));
      });

      // CTA
      var label = !v.available ? tx('soldOut', 'Sold out') : (plan ? tx('subscribe', 'Subscribe') : tx('addToCart', 'Add to cart'));
      atcLabel.textContent = label;
      if (v.available) { atc.removeAttribute('disabled'); } else { atc.setAttribute('disabled', 'disabled'); }

      // hero image (slide 0) + sticky
      if (heroImg && v.img && heroImg.getAttribute('data-src-v') !== String(v.id)) {
        heroImg.removeAttribute('srcset');
        heroImg.src = v.img;
        heroImg.setAttribute('data-src-v', String(v.id));
      }
      if (stickyImg && v.img) { stickyImg.removeAttribute('srcset'); stickyImg.src = v.img; }

      var total = unit * state.qty;
      var rate = typeof data.pointsRate === 'number' && data.pointsRate > 0 ? data.pointsRate : 1;
      if (pointsEl) pointsEl.textContent = Math.round(total / 100 * rate).toLocaleString('en-US');

      var sel = $('[data-cumf-sticky-sel]');
      if (sel) sel.textContent = v.label + ' · ' + (plan ? (data.subLabel || 'Subscribe & Save') + ' · ' + (state.freq === 12 ? tx('everyWeeks12', tx('everyWeeks', 'every {n} weeks')) : tx('everyWeeks', 'every {n} weeks')).replace('{n}', state.freq) : tx('once', 'One-time purchase'));
      var sl = $('[data-cumf-sticky-label]');
      if (sl) sl.textContent = label;
      var spr = $('[data-cumf-sticky-price]');
      if (spr) spr.textContent = moneyC(total);
    }

    function setUrlVariant(id) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    // tiles
    $$('[data-cumf-tile]').forEach(function (t) {
      t.addEventListener('click', function () {
        var id = Number(t.getAttribute('data-id'));
        if (id === state.id) return;
        state.id = id;
        render();
        setUrlVariant(id);
        gallery && gallery.go(0, true);
        var v = byId[id];
        track('size_select', { variant_id: id, size: v && v.label, price: v && v.price / 100 });
      });
    });

    // plans
    $$('[data-cumf-plan]').forEach(function (row) {
      function pick(e) {
        if (e && e.target && e.target.closest('[data-cumf-freq]')) return;
        var p = row.getAttribute('data-cumf-plan');
        if (p === state.plan) return;
        state.plan = p;
        render();
        track('plan_select', { plan: p, frequency_weeks: p === 'sub' ? state.freq : null });
      }
      row.addEventListener('click', function (e) { pick(e); if (e.detail > 0 && row.blur) row.blur(); }); // mouse/tap: no focus ring; keyboard keeps it
      row.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(e); } });
    });
    $$('[data-cumf-freq]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        state.freq = Number(b.getAttribute('data-cumf-freq'));
        state.plan = 'sub';
        render();
        track('frequency_select', { frequency_weeks: state.freq });
      });
    });

    // qty
    $$('[data-cumf-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = Number(b.getAttribute('data-cumf-qty'));
        var q = Math.max(1, Math.min(9, state.qty + d));
        if (q === state.qty) return;
        state.qty = q;
        render();
        track('qty_change', { qty: q });
      });
    });

    // ATC click (submit is handled by <product-form>)
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      form.addEventListener('submit', function () {
        // Other scripts on the page (Recharge's embed) reset name=selling_plan
        // to "" after we set it — re-apply our state at the last moment.
        // Capture-phase on the form runs before <product-form>'s handler.
        var cv = byId[state.id];
        var cp = planFor(cv);
        idInput.value = state.id;
        qtyInput.value = state.qty;
        Array.prototype.forEach.call(form.querySelectorAll('[name="selling_plan"]'), function (el) {
          if (el !== planInput) el.disabled = true;
        });
        if (cp) { planInput.disabled = false; planInput.value = cp.id; }
        else { planInput.value = ''; planInput.disabled = true; }
        var v = byId[state.id];
        track('add_to_cart_click', {
          variant_id: state.id, size: v && v.label, plan: state.plan,
          frequency_weeks: state.plan === 'sub' ? state.freq : null, qty: state.qty,
          value: v ? unitPrice(v) * state.qty / 100 : null, source: 'buy_box'
        });
      }, true);
    }

    // reviews link → Stamped widget wherever the app section rendered it
    var rl = $('[data-cumf-reviews-link]');
    if (rl) rl.addEventListener('click', function (e) {
      var target = document.getElementById('cumf-reviews') || document.querySelector('#stamped-main-widget, .stamped-main-widget, [data-widget-type="full-page"]');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      track('reviews_link_click');
    });

    // generic link tracking
    $$('[data-cumf-track]').forEach(function (a) {
      a.addEventListener('click', function () { track(a.getAttribute('data-cumf-track')); });
    });

    // accordions: one open at a time (fallback for browsers without <details name>)
    $$('[data-cumf-accs] details').forEach(function (d, i, all) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        all.forEach(function (o) { if (o !== d) o.open = false; });
        track('accordion_open', { item: d.querySelector('summary').textContent.trim() });
      });
    });

    // Recharge app embed injects its own widget (with its own selling-plan
    // inputs) into product forms. Remove it so only our fields are submitted.
    if (form) {
      var stripRc = function () {
        Array.prototype.forEach.call(form.querySelectorAll('.rc-container-wrapper, .rc_container_wrapper'), function (n) { n.remove(); });
      };
      stripRc();
      if ('MutationObserver' in window) new MutationObserver(stripRc).observe(form, { childList: true, subtree: true });
    }

    var gallery = initGallery(root);
    initSticky(root, form);
    render();
    track('view', { umf: data.umf, variant_id: state.id });
  }

  function initGallery(root) {
    var track_ = root.querySelector('[data-cumf-track]');
    if (!track_) return null;
    var slides = Array.prototype.slice.call(track_.querySelectorAll('[data-cumf-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cumf-thumb]'));
    var n = slides.length;
    var current = 0;

    // Desktop: show only the thumbs that fit beside the main image.
    var visibleThumbs = thumbs.length;
    var stage = root.querySelector('.cumf-gal__stage');
    function fitThumbs() {
      thumbs.forEach(function (t) { t.classList.remove('is-overflow'); t.removeAttribute('data-more'); });
      visibleThumbs = thumbs.length;
      if (window.innerWidth < 990 || !stage || !thumbs.length) return;
      var size = thumbs[0].offsetHeight || 72;
      var gap = parseFloat(getComputedStyle(thumbs[0].parentElement).rowGap) || 10;
      var fit = Math.max(1, Math.floor((stage.offsetHeight + gap) / (size + gap)));
      if (fit >= thumbs.length) return;
      visibleThumbs = fit;
      thumbs.forEach(function (t, k) { if (k >= fit) t.classList.add('is-overflow'); });
      thumbs[fit - 1].setAttribute('data-more', '+' + (thumbs.length - fit + 1));
    }
    fitThumbs();
    var rz = null;
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { fitThumbs(); setActive(current); }, 120); });

    function setActive(i) {
      current = i;
      var last = visibleThumbs - 1;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i || (k === last && i > last)); });
      var t = thumbs[i];
      if (t && t.parentElement && window.innerWidth < 990) {
        var p = t.parentElement;
        var left = t.offsetLeft - (p.clientWidth - t.clientWidth) / 2;
        p.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }
    function go(i, instant) {
      var k = (i + n) % n;
      track_.scrollTo({ left: k * track_.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      setActive(k);
    }
    var raf = null;
    track_.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(track_.scrollLeft / Math.max(1, track_.clientWidth));
        if (i !== current) setActive(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); track('gallery_nav', { to: i + 1, via: 'thumb' }); }); });
    var prev = root.querySelector('[data-cumf-prev]');
    var next = root.querySelector('[data-cumf-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); track('gallery_nav', { to: ((current + n) % n) + 1, via: 'arrow' }); });
    if (next) next.addEventListener('click', function () { go(current + 1); track('gallery_nav', { to: current + 1, via: 'arrow' }); });

    // ---- zoom ----
    var zoom = root.querySelector('[data-cumf-zoom]');
    var zTrack = root.querySelector('[data-cumf-zoom-track]');
    var zCount = root.querySelector('[data-cumf-zoom-count]');
    var zDots = root.querySelector('[data-cumf-zoom-dots]');
    var zHint = root.querySelector('[data-cumf-zoom-hint]');
    var zi = 0;
    var built = false;
    var lastFocus = null;

    function buildZoom() {
      if (built) return;
      built = true;
      slides.forEach(function (s) {
        var wrap = document.createElement('div');
        wrap.className = 'cumf-zoom__slide';
        var frame = document.createElement('div');
        frame.className = 'cumf-zoom__frame';
        Array.prototype.forEach.call(s.querySelectorAll('img'), function (img) {
          var c = document.createElement('img');
          c.src = (img.currentSrc || img.src).replace(/([?&]width=)\d+/, '$12000');
          c.alt = img.alt || '';
          c.className = img.className;
          frame.appendChild(c);
        });
        wrap.appendChild(frame);
        wrap.addEventListener('click', function () {
          zoom.classList.toggle('is-zoomed');
          zHint.textContent = zoom.classList.contains('is-zoomed') ? (zHint.getAttribute('data-zoomed') || 'Drag to pan · tap to fit') : (zHint.getAttribute('data-normal') || 'Swipe for more · tap image to zoom');
        });
        zTrack.appendChild(wrap);
        var d = document.createElement('span');
        zDots.appendChild(d);
      });
      zTrack.addEventListener('scroll', function () {
        if (zoom.classList.contains('is-zoomed')) return;
        var i = Math.round(zTrack.scrollLeft / Math.max(1, zTrack.clientWidth));
        if (i !== zi) zSet(i);
      }, { passive: true });
    }
    function zSet(i) {
      zi = i;
      zCount.textContent = (i + 1) + ' / ' + n;
      Array.prototype.forEach.call(zDots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    function zGo(i, instant) {
      var k = (i + n) % n;
      zoom.classList.remove('is-zoomed');
      zTrack.scrollTo({ left: k * zTrack.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      zSet(k);
    }
    function openZoom() {
      if (!zoom) return;
      buildZoom();
      // hero slide always shows the selected size
      var hero = slides[0] && slides[0].querySelector('[data-cumf-hero]');
      var zHero = zTrack.firstChild && zTrack.firstChild.querySelector('.cumf-gal__hero');
      if (hero && zHero) zHero.src = hero.currentSrc || hero.src;
      lastFocus = document.activeElement;
      zoom.hidden = false;
      document.documentElement.classList.add('cumf-noscroll');
      requestAnimationFrame(function () { zGo(current, true); });
      var close = zoom.querySelector('[data-cumf-zoom-close]');
      if (close) close.focus();
      track('zoom_open', { slide: current + 1 });
    }
    function closeZoom() {
      zoom.hidden = true;
      zoom.classList.remove('is-zoomed');
      document.documentElement.classList.remove('cumf-noscroll');
      go(zi, true);
      if (lastFocus) lastFocus.focus();
    }
    slides.forEach(function (s) { s.addEventListener('click', openZoom); });
    var zo = root.querySelector('[data-cumf-zoom-open]');
    if (zo) zo.addEventListener('click', openZoom);
    if (zoom) {
      zoom.querySelector('[data-cumf-zoom-close]').addEventListener('click', closeZoom);
      zoom.querySelector('[data-cumf-zoom-prev]').addEventListener('click', function () { zGo(zi - 1); });
      zoom.querySelector('[data-cumf-zoom-next]').addEventListener('click', function () { zGo(zi + 1); });
      document.addEventListener('keydown', function (e) {
        if (zoom.hidden) return;
        if (e.key === 'Escape') closeZoom();
        if (e.key === 'ArrowLeft') zGo(zi - 1);
        if (e.key === 'ArrowRight') zGo(zi + 1);
      });
    }
    return { go: go };
  }

  function initSticky(root, form) {
    var bar = root.querySelector('[data-cumf-sticky]');
    var atc = root.querySelector('[data-cumf-atc]');
    var btn = root.querySelector('[data-cumf-sticky-btn]');
    if (!bar || !atc) return;
    // Show only once the buy-box button has scrolled ABOVE the viewport.
    var on = null, ticking = false;
    function check() {
      ticking = false;
      var past = atc.getBoundingClientRect().bottom < 0;
      if (past === on) return;
      on = past;
      bar.classList.toggle('is-on', past);
      // Lift the Gorgias chat + UserWay bubbles above the bar while it shows.
      document.documentElement.style.setProperty('--cumf-sticky-h', bar.offsetHeight + 'px');
      document.documentElement.classList.toggle('cumf-sticky-up', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      btn.tabIndex = past ? 0 : -1;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
    btn.addEventListener('click', function () {
      track('sticky_atc_click');
      if (atc.disabled) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (form && form.requestSubmit) form.requestSubmit(atc); else atc.click();
    });
  }

  function initVideo(el) {
    var btn = el.querySelector('[data-cumf-video-play]');
    if (!btn) return;
    function start(auto) {
      if (btn.getAttribute('data-playing')) return;
      btn.setAttribute('data-playing', '1');
      var host = btn.getAttribute('data-host');
      var id = btn.getAttribute('data-vid');
      var src = btn.getAttribute('data-src');
      var node;
      if (host === 'youtube' && id) {
        node = document.createElement('iframe');
        node.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1' + (auto ? '&mute=1' : '');
        node.allow = 'autoplay; encrypted-media; picture-in-picture';
        node.allowFullscreen = true;
        node.title = 'Product video';
      } else if (host === 'vimeo' && id) {
        node = document.createElement('iframe');
        node.src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1' + (auto ? '&muted=1' : '');
        node.allow = 'autoplay; fullscreen; picture-in-picture';
        node.title = 'Product video';
      } else if (src) {
        node = document.createElement('video');
        node.src = src; node.controls = true; node.autoplay = true; node.playsInline = true; node.muted = !!auto;
      }
      if (node) {
        var play = btn.querySelector('.cumf-video__play');
        if (play) play.remove();
        btn.appendChild(node);
      }
      track(auto ? 'video_autoplay' : 'video_play');
    }
    btn.addEventListener('click', function () { start(false); });
    // autoplay (muted) once half the video is on screen; skipped for reduced-motion users
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); start(true); }
      }, { threshold: 0.5 });
      io.observe(btn);
    }
  }

  function initFaqs(el) {
    var all = el.querySelector('[data-cumf-faq-all]');
    var items = Array.prototype.slice.call(el.querySelectorAll('details'));
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
        track('faq_open', { question: d.querySelector('summary').textContent.trim() });
      });
    });
    if (!all) return;
    var open = false;
    all.addEventListener('click', function () {
      open = !open;
      Array.prototype.forEach.call(el.querySelectorAll('[data-cumf-faq-more]'), function (d) {
        d.hidden = !open;
        if (!open) d.open = false;
      });
      all.textContent = open ? all.getAttribute('data-less') : all.getAttribute('data-more');
      if (open) track('faq_show_all');
    });
  }

  function initAccr(el) {
    var tr = el.querySelector('[data-cumf-accr-track]');
    if (!tr) return;
    Array.prototype.forEach.call(el.querySelectorAll('[data-cumf-accr]'), function (b) {
      b.addEventListener('click', function () {
        tr.scrollBy({ left: Number(b.getAttribute('data-cumf-accr')) * 312, behavior: 'smooth' });
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cumf-root]'), initMain);
    Array.prototype.forEach.call(document.querySelectorAll('[data-cumf-video]'), initVideo);
    Array.prototype.forEach.call(document.querySelectorAll('[data-cumf-faqs]'), initFaqs);
    Array.prototype.forEach.call(document.querySelectorAll('.cumf-accr'), initAccr);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
